var chunkMapping = {
	"12": [
		5012
	],
	"97": [
		97
	],
	"228": [
		6228
	],
	"292": [
		864,
		2300,
		2499,
		3486,
		3675,
		4043,
		5898,
		7992,
		8211,
		8261,
		8350
	],
	"398": [
		2398
	],
	"620": [
		9620
	],
	"632": [
		7632
	],
	"672": [
		6672
	],
	"750": [
		5750
	],
	"863": [
		4863
	],
	"898": [
		9898
	]
};
var idToExternalAndNameMapping = {
	"97": [
		"default",
		"./Radio",
		1644
	],
	"864": [
		"default",
		"./category",
		5951
	],
	"2300": [
		"default",
		"./tracking",
		2774
	],
	"2398": [
		"default",
		"./LoginOrRegister",
		6851
	],
	"2499": [
		"default",
		"./reminder",
		5951
	],
	"3486": [
		"default",
		"./provider",
		5951
	],
	"3675": [
		"default",
		"./validations",
		1644
	],
	"4043": [
		"default",
		"./localStorage",
		5951
	],
	"4863": [
		"default",
		"./Spinner",
		1644
	],
	"5012": [
		"default",
		"./IMG",
		1644
	],
	"5750": [
		"default",
		"./Dropdown",
		1644
	],
	"5898": [
		"default",
		"./devicedata",
		2774
	],
	"6228": [
		"default",
		"./Input",
		1644
	],
	"6672": [
		"default",
		"./Button",
		1644
	],
	"7632": [
		"default",
		"./SVG",
		1644
	],
	"7992": [
		"default",
		"./GTM",
		2774
	],
	"8211": [
		"default",
		"./LocationWrapper",
		1644
	],
	"8261": [
		"default",
		"./global",
		1644
	],
	"8350": [
		"default",
		"./useTheme",
		1644
	],
	"9620": [
		"default",
		"./RadioBasic",
		1644
	],
	"9898": [
		"default",
		"./Icon",
		1644
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}